<template>
  <ion-page>
    <WhiteHeader :back-button="false" title="Mes entretiens engin" />

    <ReportList ref="reportList" kind="machine_report"></ReportList>
  </ion-page>
</template>

<script>
import WhiteHeader from '@/components/driver/header/WhiteHeader.vue';
import ReportList from '../common/ReportList.vue';

export default {
  name: 'ListMachineReport',
  components: {
    ReportList,
    WhiteHeader,
  },

  ionViewDidEnter() {
    if (!this.$refs.reportList) {
      console.error('ReportList reference is not available');
      return;
    }

    this.$refs.reportList.getStatuses();
  },
};
</script>
